import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { CategoriaService } from '../categoria.service';

@Component({
  selector: 'app-categoria-update',
  templateUrl: './categoria-update.component.html',
  styleUrls: ['./categoria-update.component.scss']
})
export class CategoriaUpdateComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  @Input() element: any = {}
  categorias: Array<any> = [];
  seleccionado!: number
  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public formatter: FormatterService,
    public service: CategoriaService
  ) { }

  ngOnInit(): void {
    this.select()
    this.form = this.formBuilder.group({
      id: [],
      nombre: ['', [Validators.required]],
      descripcion: [''],
      estado: ['', [Validators.required]],
      categoria_padre_id: [],
    });
    this.seleccionado = this.element.categoria_padre?.id
    this.form.patchValue(this.element);
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert(res.response, "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro", "danger");
          if (err.error.response) {
            this.alerts.addAlert(err.error.response, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  select(): void {
    this.loading.show();
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this.service.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        this.categorias = res;
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo cargar las Categorías", "danger");
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    })
  }


}
